(() => {
  
  function initMerchCollection(root){
    if (!root || !window.fetch || !window.URL || !window.history) return;

    const sectionId = root.getAttribute('data-section-id') || '';
    const rootId = root.id || '';
    const getVarNum = (name, fallback) => {
      try{
        const v = getComputedStyle(root).getPropertyValue(name).trim();
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : fallback;
      }catch(e){ return fallback; }
    };

    const MIN_LOADER_MS = getVarNum('--mc-loader-min-ms', 180);
    let busySince = 0;

        // --- Stable loader baseline height (prevents Y "jump" when results count changes) ---
    let prevInlineMinHeight = '';
    let baselineHeight = 0;

    // tenta reaproveitar baseline anterior guardado no store (entre reloads AJAX)
    try{
      const store = (window.__MerchCollection = window.__MerchCollection || {});
      if (store[sectionId] && Number.isFinite(store[sectionId].baselineHeight)) {
        baselineHeight = store[sectionId].baselineHeight;
      }
    }catch(e){}

    const measureHeight = () => {
      try { return Math.ceil(root.getBoundingClientRect().height); } catch(e){ return 0; }
    };

    const lockSectionHeight = () => {
      try{
        const h = measureHeight();

        // baseline = maior altura que já vimos (para não "andar para cima/baixo")
        baselineHeight = Math.max(baselineHeight || 0, h || 0);

        // guarda o inline anterior para restaurar depois
        prevInlineMinHeight = root.style.minHeight || '';

        // fixa min-height ao baseline durante loading
        if (baselineHeight > 0) root.style.minHeight = `${baselineHeight}px`;

        // persiste no store
        try{
          const store = (window.__MerchCollection = window.__MerchCollection || {});
          store[sectionId] = store[sectionId] || {};
          store[sectionId].baselineHeight = baselineHeight;
        }catch(e){}
      }catch(e){}
    };

    const unlockSectionHeight = () => {
      try{
        root.style.minHeight = prevInlineMinHeight || '';
        prevInlineMinHeight = '';
      }catch(e){}
    };




    const store = (window.__MerchCollection = window.__MerchCollection || {});
    if (store[sectionId] && typeof store[sectionId].cleanup === 'function') {
      try { store[sectionId].cleanup(); } catch(e) {}
    }

    const offFns = [];
    const on = (el, ev, fn, opts) => {
      if (!el) return;
      el.addEventListener(ev, fn, opts || false);
      offFns.push(() => { try { el.removeEventListener(ev, fn, opts || false); } catch(e){} });
    };

    const qs = (sel, ctx) => (ctx || root).querySelector(sel);
    const qsa = (sel, ctx) => Array.prototype.slice.call((ctx || root).querySelectorAll(sel));

    const nextFrames = (n=2) => new Promise(resolve => {
      const step = () => (n-- <= 0 ? resolve() : requestAnimationFrame(step));
      requestAnimationFrame(step);
    });

    const ensureMinLoaderTime = () => {
      const elapsed = Date.now() - (busySince || 0);
      const wait = Math.max(0, MIN_LOADER_MS - elapsed);
      return new Promise(r => setTimeout(r, wait));
    };

    const setBusy = (mode) => {
    try{
      if (mode === 'boot' || mode === 'load') busySince = Date.now();

      // ✅ congela altura quando começa loading (evita salto do centro do loader)
      if (mode === 'load') lockSectionHeight();
      if (mode === 'boot') lockSectionHeight();

      root.classList.toggle('is-booting', mode === 'boot');
      root.classList.toggle('is-loading', mode === 'load');
      root.classList.remove('is-revealing');
      root.classList.remove('is-ready');

      void root.offsetHeight;
    }catch(e){}
  };


    const fontsReady = () => {
      try{
        if (document.fonts && document.fonts.ready) return document.fonts.ready.catch(() => {});
      }catch(e){}
      return Promise.resolve();
    };

    // --- Judge.me: render + hydrate count from injected DOM ---
    const mcHydrateJudgeMe = (container) => {
      try{
        container = container || root;

        // força o JM a renderizar badges quando o HTML muda (AJAX)
        if (window.jdgm && typeof window.jdgm.renderBadges === "function") {
          window.jdgm.renderBadges(container);
        }

        requestAnimationFrame(() => {
          try{
            container.querySelectorAll("[data-jm-wrap]").forEach((wrap) => {
              const badge = wrap.querySelector(".jdgm-prev-badge");
              if (!badge) return;

              const n = parseInt(badge.getAttribute("data-number-of-reviews") || "0", 10);

              const countEl = wrap.querySelector("[data-jm-count]");
              const emptyEl = wrap.querySelector("[data-jm-empty]");

              if (n > 0) {
                if (countEl) {
                  countEl.textContent = `(${n})`;
                  countEl.hidden = false;
                }
                if (emptyEl) emptyEl.hidden = true;
              } else {
                if (countEl) countEl.hidden = true;
                if (emptyEl) emptyEl.hidden = false;
              }
            });
          }catch(e){}
        });
      }catch(e){}
    };


    const judgeMeReady = (container) => {
      container = container || root;
      const hasBadge = !!container.querySelector('.jdgm-widget, .jdgm-prev-badge, [class*="jdgm-"]');
      if (!hasBadge) return Promise.resolve();

      return new Promise(resolve => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          clearTimeout(t);
          try{ obs && obs.disconnect(); }catch(e){}
          resolve();
        };

        const t = setTimeout(finish, 1200);

        let obs;
        try{
          obs = new MutationObserver(() => {
            const ok =
              container.querySelector('.jdgm-prev-badge__stars, .jdgm-star, .jdgm-prev-badge') ||
              container.querySelector('[class*="jdgm-"] svg');
            if (ok) finish();
          });
          obs.observe(container, { childList:true, subtree:true });
        }catch(e){}

        const immediateOk =
          container.querySelector('.jdgm-prev-badge__stars, .jdgm-star, .jdgm-prev-badge') ||
          container.querySelector('[class*="jdgm-"] svg');
        if (immediateOk) finish();
      });
    };

    
    const waitStableLayout = (container, stableMs = 260, maxMs = 2200) => {
      container = container || root;
      return new Promise((resolve) => {
        let done = false;
        let lastChange = Date.now();
        const finish = () => {
          if (done) return;
          done = true;
          try{ ro && ro.disconnect(); }catch(e){}
          resolve();
        };

        const deadline = setTimeout(finish, maxMs);

        let ro;
        if (window.ResizeObserver){
          try{
            ro = new ResizeObserver(() => { lastChange = Date.now(); });
            ro.observe(container);
          }catch(e){}
        }

        const tick = () => {
          if (done) return;
          if ((Date.now() - lastChange) >= stableMs) {
            clearTimeout(deadline);
            finish();
            return;
          }
          setTimeout(tick, 40);
        };
        tick();
      });
    };
const revealWhenReady = async (container) => {
      container = container || root;

      // garante que o estado "hidden" foi pintado antes de fazer reveal
      await nextFrames(2);

      await fontsReady();
      await judgeMeReady(container);
      await waitStableLayout(container.querySelector('[data-mc-stage]') || container);

      await ensureMinLoaderTime();

      // 2 frames extra antes de remover classes => transition dispara sempre
      await nextFrames(2);

      try{
        container.classList.remove('is-booting');
        container.classList.remove('is-loading');

        // força o estado opacity:0 ser "commitado"
        try{ void container.offsetHeight; }catch(e){}

        // adiciona is-ready no frame seguinte => fade garantido
        requestAnimationFrame(() => {
        try{ container.classList.add('is-ready'); }catch(e){}

        // ✅ solta a altura depois do fade (assim não há jump)
        const ms = getVarNum('--mc-reveal-ms', 250);
        setTimeout(() => {
          try{ unlockSectionHeight(); }catch(e){}
        }, Math.max(0, ms) + 50);
      });

      }catch(e){}

    };

    // drawer (mobile)
    const lockBody = (lock) => {
      try{
        document.body.style.overflow = lock ? 'hidden' : '';
        document.body.style.touchAction = lock ? 'none' : '';
      }catch(e){}
    };

    const isFiltersOpen = () => {
      const sidebar = qs('[data-mc-sidebar]');
      return !!(sidebar && sidebar.classList.contains('is-open'));
    };


    // --- Portal (move overlay + sidebar para <body> para ficar acima de header/sections) ---
    let portal = {
      active: false,
      sidebarParent: null,
      overlayParent: null,
      sidebarPlaceholder: null,
      overlayPlaceholder: null
    };

    // --- copy CSS vars (--mc-*) from section root to a moved node (portal) ---
    const copyMcVars = (targetEl) => {
      try{
        if (!targetEl) return;
        const cs = getComputedStyle(root);
        for (let i = 0; i < cs.length; i++){
          const prop = cs[i];
          if (prop && prop.startsWith('--mc-')){
            targetEl.style.setProperty(prop, cs.getPropertyValue(prop));
          }
        }
      }catch(e){}
    };


    const portalMount = () => {
      const sidebar = qs('[data-mc-sidebar]');
      const overlay = qs('[data-mc-overlay]');
      if (!sidebar || !overlay) return;

      if (portal.active) return;

      // placeholders para voltar ao sítio certo
      portal.sidebarParent = sidebar.parentNode;
      portal.overlayParent = overlay.parentNode;

      portal.sidebarPlaceholder = document.createComment('mc-sidebar-placeholder');
      portal.overlayPlaceholder = document.createComment('mc-overlay-placeholder');

      portal.sidebarParent.insertBefore(portal.sidebarPlaceholder, sidebar);
      portal.overlayParent.insertBefore(portal.overlayPlaceholder, overlay);

      // move para body
      document.body.appendChild(overlay);
      document.body.appendChild(sidebar);

      copyMcVars(overlay);
      copyMcVars(sidebar);

      // classes de portal (CSS do patch)
      overlay.classList.add('mc__portal-overlay');
      sidebar.classList.add('mc__portal-sidebar');

      portal.active = true;
    };

    const portalUnmount = () => {
      const sidebar = qs('[data-mc-sidebar]') || document.querySelector('.mc__portal-sidebar');
      const overlay = qs('[data-mc-overlay]') || document.querySelector('.mc__portal-overlay');
      if (!portal.active) return;

      try{
        if (overlay && portal.overlayPlaceholder && portal.overlayParent){
          portal.overlayParent.insertBefore(overlay, portal.overlayPlaceholder);
          portal.overlayPlaceholder.remove();
        }
        if (sidebar && portal.sidebarPlaceholder && portal.sidebarParent){
          portal.sidebarParent.insertBefore(sidebar, portal.sidebarPlaceholder);
          portal.sidebarPlaceholder.remove();
        }
      }catch(e){}

      try{
        overlay && overlay.classList.remove('mc__portal-overlay','is-show');
        sidebar && sidebar.classList.remove('mc__portal-sidebar');
      }catch(e){}

      portal = { active:false, sidebarParent:null, overlayParent:null, sidebarPlaceholder:null, overlayPlaceholder:null };
    };


    const openFilters = () => {
      const sidebar = qs('[data-mc-sidebar]');
      const overlay = qs('[data-mc-overlay]');
      const btn = qs('[data-mc-filters-open]');
      if (!sidebar || !overlay) return;

      portalMount();

      // reset estado drag
      sidebar.classList.remove('is-dragging');
      sidebar.style.removeProperty('--mc-sheet-drag');

      overlay.hidden = false;
      overlay.classList.add('is-show');
      overlay.style.display = 'block';

      sidebar.classList.add('is-open');

      if (btn) btn.setAttribute('aria-expanded', 'true');
      lockBody(true);
    };


    const closeFilters = (opts = {}) => {
      const sidebar = qs('[data-mc-sidebar]') || document.querySelector('.mc__portal-sidebar');
      const overlay = qs('[data-mc-overlay]') || document.querySelector('.mc__portal-overlay');
      const btn = qs('[data-mc-filters-open]');
      if (!sidebar || !overlay) return;

      // evita duplo close
      if (sidebar.classList.contains('is-closing')) return;

      const immediate = !!opts.immediate;

      // reset overlay opacity (caso estivesse a arrastar)
      overlay.style.opacity = '';

      if (immediate){
        sidebar.classList.remove('is-open', 'is-dragging', 'is-closing');
        sidebar.style.removeProperty('--mc-sheet-drag');

        overlay.hidden = true;
        overlay.classList.remove('is-show');
        overlay.style.display = 'none';

        if (btn) btn.setAttribute('aria-expanded', 'false');
        lockBody(false);
        portalUnmount();
        return;
      }

      // animação slide down
      sidebar.classList.add('is-closing');
      sidebar.classList.remove('is-open', 'is-dragging');
      sidebar.style.removeProperty('--mc-sheet-drag');

      // força ir para baixo (CSS base do sheet deve fazer translateY(110%))
      sidebar.style.transform = 'translate3d(0, 110%, 0)';

      const finish = () => {
        try{
          sidebar.classList.remove('is-closing');
          sidebar.style.transform = '';
          sidebar.style.removeProperty('--mc-sheet-drag');

          overlay.hidden = true;
          overlay.classList.remove('is-show');
          overlay.style.display = 'none';
          overlay.style.opacity = '';

          if (btn) btn.setAttribute('aria-expanded', 'false');
          lockBody(false);

          portalUnmount();
        }catch(e){}
      };

      const t = setTimeout(finish, 320);
      sidebar.addEventListener('transitionend', function onEnd(ev){
        if (ev.propertyName !== 'transform') return;
        sidebar.removeEventListener('transitionend', onEnd);
        clearTimeout(t);
        finish();
      });
    };

    const bindBottomSheetDrag = () => {
      const sidebar = qs('[data-mc-sidebar]') || document.querySelector('.mc__portal-sidebar');
      if (!sidebar) return;

      // evita listeners duplicados
      if (sidebar.__mcDragBound) return;
      sidebar.__mcDragBound = true;

      const header = sidebar.querySelector('.mc__sidebar-top') || sidebar;

      let startY = 0;
      let dragging = false;

      const CLOSE_PX = 140;      // distância para fechar
      const MAX_UP = 120;        // máximo rubberband para cima (px)
      const UP_RESIST = 0.35;    // resistência (quanto menor, mais “pesado”)

      let lastY = 0;
      let lastT = 0;
      let vy = 0;
      let downY = 0;             // só conta drag para baixo p/ fechar

      const canStartDrag = (e) => {
        if (!window.matchMedia || !matchMedia('(max-width: 1199px)').matches) return false;
        if (!sidebar.classList.contains('is-open')) return false;

        const t = e.target;
        // não começar drag em elementos interativos
        if (t && (t.closest('button') || t.closest('a') || t.closest('input') || t.closest('select'))) return false;

        return true;
      };

      const onDown = (e) => {
        if (!canStartDrag(e)) return;

        dragging = true;
        sidebar.classList.add('is-dragging');

        startY = (e.touches ? e.touches[0].clientY : e.clientY);
        lastY = startY;
        lastT = performance.now();
        vy = 0;
        downY = 0;

        sidebar.style.setProperty('--mc-sheet-drag', '0px');

        e.preventDefault();
      };

      const onMove = (e) => {
        if (!dragging) return;

        const y = (e.touches ? e.touches[0].clientY : e.clientY);
        const dyRaw = y - startY;

        // velocidade (px/ms)
        const now = performance.now();
        const dt = Math.max(1, now - lastT);
        vy = (y - lastY) / dt;
        lastY = y;
        lastT = now;

        let dragPx = dyRaw;

        // rubberband para cima (dyRaw negativo)
        if (dyRaw < 0) {
          const up = Math.min(MAX_UP, Math.abs(dyRaw));
          dragPx = -up * UP_RESIST;
        }

        // para fechar conta só o arrasto para baixo
        downY = Math.max(0, dyRaw);

        // aplica via CSS var (ganha ao transform !important do is-open)
        sidebar.style.setProperty('--mc-sheet-drag', `${dragPx}px`);

        // overlay fade só quando vai para baixo
        const overlay = document.querySelector('.mc__portal-overlay') || qs('[data-mc-overlay]');
        if (overlay) {
          if (downY > 0) {
            const a = 1 - Math.min(0.65, downY / 500);
            overlay.style.opacity = String(a);
          } else overlay.style.opacity = '';
        }

        e.preventDefault();
      };

      const onUp = () => {
        if (!dragging) return;
        dragging = false;

        sidebar.classList.remove('is-dragging');
        sidebar.style.removeProperty('--mc-sheet-drag');

        const overlay = document.querySelector('.mc__portal-overlay') || qs('[data-mc-overlay]');
        if (overlay) overlay.style.opacity = '';

        const velocityDown = vy > 0 ? (vy * 1000) : 0; // px/s aprox
        const shouldClose = (downY > CLOSE_PX) || (velocityDown > 900);

        if (shouldClose) closeFilters();
        else sidebar.classList.add('is-open');
      };

      // touch
      header.addEventListener('touchstart', onDown, { passive: false });
      header.addEventListener('touchmove', onMove, { passive: false });
      header.addEventListener('touchend', onUp, { passive: true });
      header.addEventListener('touchcancel', onUp, { passive: true });

      // pointer
      header.addEventListener('pointerdown', onDown, { passive: false });
      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp, { passive: true });

      offFns.push(() => {
        try{ sidebar.__mcDragBound = false; }catch(e){}
        header.removeEventListener('touchstart', onDown);
        header.removeEventListener('touchmove', onMove);
        header.removeEventListener('touchend', onUp);
        header.removeEventListener('touchcancel', onUp);

        header.removeEventListener('pointerdown', onDown);
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
      });
    };


    const bindDrawer = () => {
      on(qs('[data-mc-filters-open]'), 'click', openFilters);

      // podes manter o X a fechar, mas não depende dele
      on(qs('[data-mc-filters-close]'), 'click', () => closeFilters());

      // tap fora fecha com animação
      on(qs('[data-mc-overlay]'), 'click', () => closeFilters());

      on(document, 'keydown', (e) => { if (e.key === 'Escape') closeFilters(); });

      // liga drag 1x (tem guard __mcDragBound)
      bindBottomSheetDrag();

      const bindSwipeGestures = () => {
      let startX = 0, startY = 0, tracking = false;

      // tunáveis
      const EDGE_PX = 22;        // só abre se começar perto da margem esquerda
      const MIN_X = 60;          // distância mínima em X
      const MAX_Y = 40;          // tolerância vertical
      const sidebarSel = '[data-mc-sidebar]';

      const onStart = (e) => {
        const t = e.touches ? e.touches[0] : e;
        startX = t.clientX;
        startY = t.clientY;
        tracking = true;
      };

      const onEnd = (e) => {
        if (!tracking) return;
        tracking = false;

        const t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : e;
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;

        if (Math.abs(dy) > MAX_Y) return;          // foi scroll, ignora
        if (Math.abs(dx) < MIN_X) return;          // swipe curto, ignora

        const sidebar = qs(sidebarSel);
        const open = isFiltersOpen();

        // 1) Abrir: swipe left -> right a partir da margem esquerda
        if (!open && startX <= EDGE_PX && dx > 0) {
          openFilters();
          return;
        }

        // 2) Fechar: swipe right -> left quando drawer está aberto
        if (open && dx < 0) {
          // opcional: só fechar se o gesto começou dentro do drawer
          const startedInsideSidebar = sidebar && startX >= (sidebar.getBoundingClientRect().left);
          if (startedInsideSidebar) closeFilters();
        }
      };

      // usa touch events (mais consistente em iOS)
      on(document, 'touchstart', onStart, { passive: true });
      on(document, 'touchend', onEnd, { passive: true });
    };

    bindSwipeGestures();

    };

    // keep open facets
    const getOpenFacetsIndexes = () => {
      const idxs = [];
      qsa('.mc__sidebar .mc__facet').forEach((facet, idx) => {
        if (facet && facet.open) idxs.push(idx);
      });
      return idxs;
    };

    const restoreOpenFacets = (indexes) => {
      const facets = qsa('.mc__sidebar .mc__facet');
      indexes.forEach(i => { if (facets[i]) facets[i].setAttribute('open', 'open'); });
    };

    // mobile swipes
    const initMobileSwipes = (container) => {
      container = container || root;

      const IS_TOUCH_LOCAL =
        (window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
        ('ontouchstart' in window);

      if (!IS_TOUCH_LOCAL) return; // ✅ touch only (mobile/tablet/pc touch)

      qsa('[data-mc-swipe]', container).forEach(swipe => {
        const track = swipe.querySelector('[data-mc-swipe-track]');
        const dotsWrap = swipe.querySelector('[data-mc-dots]');
        const tapLink = swipe.querySelector('[data-mc-tap]');
        if (!track || !tapLink) return;

        const href = tapLink.getAttribute('href');
        if (!href) return;

        // ✅ No touch não queremos overlay link a bloquear swipe
        const isTouch = window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches;
        if (isTouch) tapLink.style.pointerEvents = 'none';

        // Dots (se existirem)
        if (dotsWrap) {
          const dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.mc__dot'));
          const setActive = (i) => {
            if (!dots.length) return;
            i = Math.max(0, Math.min(dots.length - 1, i));
            dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
          };
          const calcIndex = () => {
            const w = track.clientWidth || 1;
            return Math.floor((track.scrollLeft + (w * 0.5)) / w);
          };
          setActive(calcIndex());
          let raf = 0;
          track.addEventListener('scroll', () => {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => setActive(calcIndex()));
          }, { passive:true });
        }

        // ✅ Tap vs Swipe gate
        let startX = 0, startY = 0, moved = false;
        const MOVE_PX = 10; // limiar para considerar swipe

        const onStart = (e) => {
          const p = e.touches ? e.touches[0] : e;
          startX = p.clientX;
          startY = p.clientY;
          moved = false;
        };

        const onMove = (e) => {
          const p = e.touches ? e.touches[0] : e;
          const dx = Math.abs(p.clientX - startX);
          const dy = Math.abs(p.clientY - startY);
          if (dx > MOVE_PX || dy > MOVE_PX) moved = true;
        };

        const onEnd = () => {
          // se houve swipe/movimento, não abre
          if (moved) return;
          window.location.href = href;
        };

        // Touch (mobile/tablet)
        track.addEventListener('touchstart', onStart, { passive: true });
        track.addEventListener('touchmove', onMove, { passive: true });
        track.addEventListener('touchend', onEnd, { passive: true });

        // Pointer (tablet/desktop touch + compat)
        track.addEventListener('pointerdown', onStart, { passive: true });
        track.addEventListener('pointermove', onMove, { passive: true });
        track.addEventListener('pointerup', onEnd, { passive: true });
      });

    };

    // sliders
    const initSliders = (container) => {
      qsa('[data-price-slider]', container).forEach(wrapper => {
        const input = wrapper.querySelector('[data-slider-input]');
        const valueEl = wrapper.querySelector('[data-slider-value]');
        if (!input || !valueEl) return;

        const currency = (wrapper.getAttribute('data-currency') || '').trim();
        const minParam = wrapper.getAttribute('data-min-param');
        const maxParam = wrapper.getAttribute('data-max-param');
        const minDefault = parseInt(wrapper.getAttribute('data-min-default') || '0', 10);

        const formatCents = (cents) => {
          const n = cents / 100;
          const txt = n.toFixed(2).replace(/\.00$/, '');
          return currency ? (currency + ' ' + txt) : txt;
        };

        on(input, 'input', () => {
          const v = parseInt(input.value || '0', 10);
          valueEl.textContent = formatCents(v);
        });

        on(input, 'change', () => {
          const v = parseInt(input.value || '0', 10);
          const url = new URL(window.location.href);

          const toMoneyParam = (cents) => {
            const n = cents / 100;
            return n.toFixed(2).replace(/\.00$/, '');
          };

          if (maxParam) url.searchParams.set(maxParam, toMoneyParam(v));
          if (minParam && !url.searchParams.get(minParam)) url.searchParams.set(minParam, toMoneyParam(minDefault));
          url.searchParams.delete('page');

          fetchAndRender(url.toString(), { push:true });
        });
      });
    };

    // custom selects
    const closeAllSelects = (container) => {
      qsa('[data-mc-select]', container).forEach(wrap => {
        const btn = wrap.querySelector('[data-mc-select-btn]');
        const menu = wrap.querySelector('[data-mc-select-menu]');
        if (!btn || !menu) return;
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      });
    };

    const initCustomSelects = (container) => {
      qsa('[data-mc-select]', container).forEach(wrap => {
        if (wrap.getAttribute('data-mc-select-init') === '1') return;
        wrap.setAttribute('data-mc-select-init', '1');

        const select = wrap.querySelector('select');
        const btn = wrap.querySelector('[data-mc-select-btn]');
        const text = wrap.querySelector('[data-mc-select-text]');
        const menu = wrap.querySelector('[data-mc-select-menu]');
        const list = wrap.querySelector('[data-mc-select-list]');
        if (!select || !btn || !text || !menu || !list) return;

        wrap.classList.add('is-enhanced');

        const syncLabel = () => {
          const opt = select.options[select.selectedIndex];
          text.textContent = opt ? opt.textContent : '';
        };

        const build = () => {
          list.innerHTML = '';
          Array.prototype.slice.call(select.options).forEach(opt => {
            const li = document.createElement('li');
            li.className = 'mc__select-opt' + (opt.selected ? ' is-active' : '');
            li.setAttribute('role', 'option');
            li.innerHTML = '<span class="lbl"></span><span class="tick" aria-hidden="true"></span>';
            li.querySelector('.lbl').textContent = opt.textContent;

            li.addEventListener('click', (e) => {
              e.preventDefault();
              select.value = opt.value;
              select.dispatchEvent(new Event('change', { bubbles:true }));
              close();
            });

            list.appendChild(li);
          });
        };

        const open = () => {
          closeAllSelects(container);
          build();
          syncLabel();
          menu.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        };

        const close = () => {
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        };

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (menu.hidden) open();
          else close();
        });

        document.addEventListener('click', (e) => {
          if (!wrap.contains(e.target)) close();
        }, true);

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') close();
        }, true);

        window.addEventListener('scroll', close, { passive:true });
        window.addEventListener('resize', close, { passive:true });

        syncLabel();
        select.addEventListener('change', syncLabel);
      });
    };

    // cart helpers
    const getCart = async () => {
      const cartRes = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!cartRes.ok) throw new Error('Failed to fetch cart');
      return await cartRes.json();
    };

    const updateHeaderCartBubble = (cart) => {
      const a = document.getElementById('cart-icon-bubble');
      const itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
      if (!a) return;

      let bubble = a.querySelector('.cart-count-bubble');

      if (itemCount > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          a.appendChild(bubble);
        }
        const visible = bubble.querySelector('span[aria-hidden="true"]');
        if (visible) visible.textContent = itemCount < 100 ? String(itemCount) : '';
        const sr = bubble.querySelector('span.visually-hidden');
        if (sr) sr.textContent = 'Carrinho com ' + String(itemCount) + ' itens';
      } else {
        if (bubble) bubble.remove();
      }
    };

    const updateSelectorBadge = (cart) => {
      try{
        const sel = root.getAttribute('data-cart-count-selector') || '';
        if (!sel) return;
        const el = document.querySelector(sel);
        if (!el) return;
        el.textContent = String(cart.item_count || 0);
        el.setAttribute('aria-label', 'Carrinho com ' + String(cart.item_count || 0) + ' itens');
      }catch(e){}
    };

    const dispatchCartEvents = (cart) => {
      try{
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:change',  { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:added',   { detail: cart }));
      }catch(e){}
    };

    const addToCart = async (variantId, qty) => {
      if (!variantId) return;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(qty || 1) })
      });
      if (!res.ok) throw new Error(await res.text() || 'Add to cart failed');
      await res.json();

      const cart = await getCart();
      updateHeaderCartBubble(cart);
      updateSelectorBadge(cart);
      dispatchCartEvents(cart);
      return cart;
    };

    // ✅ async fetchAndRender (no illegal await)
    const fetchAndRender = async (href, opts={}) => {
      if (!href) return;

      setBusy('load');
      closeFilters();
      closeAllSelects(root);

      const openIndexes = getOpenFacetsIndexes();

      const pageUrl = new URL(href, window.location.origin);
      const sectionUrl = new URL(href, window.location.origin);
      sectionUrl.searchParams.set('section_id', sectionId);

      let html;
      try{
        const res = await fetch(sectionUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        html = await res.text();
      }catch(e){
        window.location.href = href;
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = html;

      let newSection =
        (rootId ? temp.querySelector('#' + CSS.escape(rootId)) : null) ||
        temp.querySelector('[data-section-id="' + sectionId + '"]');

      if (!newSection){
        window.location.href = href;
        return;
      }

      newSection.querySelectorAll('script').forEach(s => s.remove());
      newSection.classList.add('is-loading');

      root.replaceWith(newSection);
      root = newSection;

                    try{ root.classList.remove("is-ready"); }catch(e){}
// force loading styles apply
      void root.offsetHeight;

      restoreOpenFacets(openIndexes);

      // re-init on replaced root
      initMerchCollection(root);

      try{
        if (window.jdgm && typeof window.jdgm.renderBadges === "function") window.jdgm.renderBadges(root);
      }catch(e){}


      if (opts.push) history.pushState({ mc_section_id: sectionId }, '', pageUrl.toString());
      else history.replaceState({ mc_section_id: sectionId }, '', pageUrl.toString());
    };

    // handlers
    const handleClick = (e) => {
      const link = e.target.closest('.mc__check, .mc__chip, .mc__pagination a, .mc__clear');
      if (link && root.contains(link)){
        if (link.classList.contains('mc__check--link')) return;
        e.preventDefault();
        fetchAndRender(link.href, { push:true });
        return;
      }

      const btn = e.target.closest('[data-add-to-cart]');
      if (btn && root.contains(btn)){
        e.preventDefault();
        e.stopPropagation();

        const vid = btn.getAttribute('data-variant-id');
        const qty = btn.getAttribute('data-qty') || '1';

        btn.disabled = true;
        btn.classList.add('is-loading');

        addToCart(vid, qty)
          .catch(() => { window.location.href = '/cart'; })
          .finally(() => {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          });
      }
    };

    const handleChange = (e) => {
      if (e.target.matches('.mc__sort select[name="sort_by"]')){
        const url = new URL(window.location.href);
        const val = e.target.value || '';
        if (val) url.searchParams.set('sort_by', val);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        e.preventDefault();
        fetchAndRender(url.toString(), { push:true });
      }
    };

    // bind
    on(root, 'click', handleClick);
    on(root, 'change', handleChange);

    on(window, 'popstate', () => fetchAndRender(window.location.href, { push:false }));

    // ---- TOUCH MODE FLAG (para CSS: .is-touch) ----
    const IS_TOUCH_LOCAL =
      (window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      ('ontouchstart' in window);

    root.classList.toggle('is-touch', !!IS_TOUCH_LOCAL);

    bindDrawer();
    initSliders(root);
    initMobileSwipes(root);
    initCustomSelects(root);

    setBusy('boot');
    mcHydrateJudgeMe(root);
    revealWhenReady(root);

    store[sectionId] = { cleanup: () => {
      try{ portalUnmount(); }catch(e){}
      offFns.forEach(fn => fn());
    }};

  }

  

  function initAll(){
    document.querySelectorAll('.merch-collection[data-section-id]').forEach(initMerchCollection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target && e.target.querySelector && e.target.querySelector('.merch-collection[data-section-id]');
    if (root) initMerchCollection(root);
  });
})();
